export default (value) => {
  let temp = {};
  if (Array.isArray(value)) {
    temp = value.map((e) => ({
      name: e?.alt || "",
      url: e?.path || "",
      id: e?.id,
    }));
  } else {
    temp = [
      {
        name: value?.alt || "",
        url: value?.path || "",
        id: value?.id,
      },
    ];
  }

  return temp;
};
